<template>
    <div class="about">
        <van-sticky>
            <van-nav-bar title="常见问题" :border="false" left-arrow @click-left="goBack">
            </van-nav-bar>
        </van-sticky>

        <van-cell-group v-if="viewType=='list'">
            <van-cell title="测速达标" is-link/>
            <van-cell title="宽带提速规则说明" is-link/>
            <van-cell title="查看支持宽带提速的区域" is-link/>
            <van-cell title="如何绑定和解绑微信？" is-link/>
        </van-cell-group>

        <van-collapse v-model="activeName" accordion>
            <van-collapse-item title="测速达标" name="1">
                <p>一、宽带未达标</p>
                <p>影响宽带测速未达标的因素有很多，如：</p>
                <p>1、Wifi频段影响；</p>
                <p>wifi频段为2.4G，wifi信号最大支持下载速率为54Mbps，若签约带宽大于或等于54Mbps，请使用支持无线信号模式为802.11n、802.11ac路由器。</p>
                <p>2、无线wifi 周围环境的影响</p>
                <p>请保持手机机与路由器距离保持1米左右，避免中间有障碍物遮挡。</p>
                <p>3、开启多资源消耗型应用</p>
                <p>导致测速结果低于签约带宽，请关闭其他应用再测速。</p>
                <p></p>
                <p>二、移动测速未达标</p>
                <p>影响移动测速未达标的因素有很多，如：</p>
                <p>1、基站网络覆盖不够；</p>
                <p>附近的基站可能较远，或者大型障碍物遮挡。</p>
                <p>2、附件移动用户上网用户多</p>
                <p>附件移动上网用户越来越多，导致附近基站都人满为患，随机带来的就是网速均分到每个人身上没有多少。</p>
                <p>3、手机基带信号接收不良</p>


            </van-collapse-item>
            <van-collapse-item title="苹果手机由于系统原因，缺少一些功能" name="8">

                <div class="wcc-content">由于系统原因，网查查APP在苹果手机中无法提供或有差异的功能如下：</div>
                <div class="wcc-content">Wi-Fi测速时不一定能提供ssid</div>
                <div class="wcc-content">Wi-Fi测速时不能提供wifi频段</div>
                <div class="wcc-content">Wi-Fi测速时苹果手机获得的WIFI信号强度不准确，某些型号不能获取</div>
                <div class="wcc-content">Wi-Fi测速时不能提供协商连接速率</div>
                <div class="wcc-content">Wi-Fi测速后，不能提供“为什么未达标”的检测服务</div>
                <div class="wcc-content">移动网络测速时，不能提供cell id</div>
                <div class="wcc-content">移动网络测速时，不能提供信号强度</div>
                <div class="wcc-content">查故障中的“宽带网络问题”不能提供“专业调优”服务</div>
                <div class="wcc-content">专项检测中，不能提供“路由器质量检测”服务</div>
                <div class="wcc-content">专项检测中，不能提供“移动信号检测”服务</div>
            </van-collapse-item>
        </van-collapse>
    </div>
</template>

<script>
    export default {
        data: function () {
            return {
                viewType: 'list1',
                activeName: "0",
                checked: false
            }
        },
        methods: {
            goBack: function () {
                if (window.JSInterface) {
                    window.JSInterface.callMethod('close', null)
                }
                else if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.JSInterface) {
                    window.webkit.messageHandlers.JSInterface.postMessage("{\"method\":\"close\"}");
                }
            },
            signout: function () {
                this.axios.post("/openApi/signout");
                if (window.JSInterface) {
                    window.JSInterface.callMethod('reset', null)
                }
                else if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.JSInterface) {
                    window.webkit.messageHandlers.JSInterface.postMessage("{\"method\":\"reset\"}");
                }
            }
        }
    }
</script>

<style scoped>
    .wcc-table td {
        border-top: 1px solid #353f53;
        border-left: 1px solid #353f53;
        padding: 3px;
    }

    .wcc-table {
        margin: 0 auto;
        border-bottom: 1px solid #353f53;
        border-right: 1px solid #353f53;
    }

    .wcc-tb-header {
        text-align: center;
        background-color: #FFFFFF;
    }

    .van-collapse-item__content {
        background-color: #FFFFFF;
    }

    .van-checkbox__label {
        color: inherit;
    }

    .wcc-header-1 {
        text-align: center;
        font-size: 1.2em;
        line-height: 2em;
        font-weight: bold;
        margin-bottom: 10px;
    }

    .wcc-header-2 {
        font-size: 1.1em;
        line-height: 2em;
        font-weight: bold;
    }

    .wcc-content {
        text-indent: 2em;
        margin-bottom: 10px;
    }

    .van-nav-bar {
        background-color: #FFFFFF;
    }

    .about {
        background-color: #FFFFFF;
    }

    body {
        color: #515a6e;
        background-color: #FFFFFF;
    }

    .van-cell {
        background-color: #FFFFFF;
        color: #515a6e;
    }

    .van-cell__title {
        color: #515a6e;

    }

    .van-cell--clickable {
        background-color: #FFFFFF;
    }

    .van-collapse-item__title--expanded {
        background-color: #FFFFFF;
    }

    .van-cell--clickable:active {
        background-color: #FFFFFF;
    }

</style>
